import React from 'react';
export function MissionVision() {
  return <section id="mission" className="grid lg:grid-cols-2" data-id="element-197" data-mp="3gl8xtdnqpeur">
      <div className="bg-sand px-5 py-20 md:px-12 md:py-28 lg:px-16" data-id="element-198" data-mp="5mooq820cqfz">
        <h2 className="font-display text-5xl uppercase text-catracho md:text-7xl" data-id="element-199" data-mp="jd1zei6aaj90">Mission</h2>
        <p className="mt-8 text-2xl font-bold leading-snug text-ink md:text-3xl" data-id="element-200" data-mp="fbor81fpy3yx">
          To amplify and connect Los Angeles Hondurans with their roots — through community work, cultural exposure,
          and social justice.
        </p>
        <p className="mt-6 text-lg leading-relaxed text-ink/75" data-id="element-201" data-mp="3itgqm0w6pq75">
          Along the way, we foster economic opportunity and build partnerships that strengthen our community
          today and for generations to come.
        </p>
      </div>

      <div className="bg-sunset px-5 py-20 md:px-12 md:py-28 lg:px-16" data-id="element-202" data-mp="3rvg8swixr0bo">
        <h2 className="font-display text-5xl uppercase text-ink md:text-7xl" data-id="element-203" data-mp="1c0ebfyetj8o2">Vision</h2>
        <p className="mt-8 text-2xl font-bold leading-snug text-ink md:text-3xl" data-id="element-204" data-mp="17231zosfr06d">
          A Los Angeles where Honduran-owned businesses thrive across the city, where our community comes together each
          year to celebrate,
        </p>
        <p className="mt-6 font-script text-4xl leading-tight text-sand md:text-5xl" data-id="element-205" data-mp="13yb85cd9glo6">
          and where the next generation grows up knowing their heritage is a source of pride and possibility.
        </p>
      </div>
    </section>;
}